import React, { useState } from 'react';
import { Nav, NavItem} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faNewspaper, faLocationArrow, faMap } from '@fortawesome/free-solid-svg-icons';

const tabs = [{
  route: "/home",
  icon: faHome,
  label: "Home"
},
{
  route: "/map",
  icon: faMap,
  label: "Map"
},{
  route: "/myspots",
  icon: faLocationArrow,
  label: "My Spots"
},{
  route: "/news",
  icon: faNewspaper,
  label: "News"
}
]

const Navigation = ({originalTitle}) => {

  const logoStyle = {
    borderRadius: 70,
    width: '50px',
    height: '50px',
  };

  const titleStyle = {
    margin: '0',
    lineHeight: '2.15',
    fontSize: '1rem'
  }

  const shareStyle = {
    margin: '5',
    lineHeight: '2.15',
    fontSize: 20
  }

  return (
     <div >
      <nav className="navbar navbar-expand-md navbar-light d-none d-lg-block sticky-top" role="navigation">
      <div className="w-100">
        <div className="container-fluid">
         
            <a className="navbar-brand" href="/forecast">
              <img alt="Remy Sharp" src="/surf-bros-logo-2.jpg" style={logoStyle} />
              <span>  Surf Bros</span>
            </a>
            
            <Nav className="ml-auto ">
              <NavItem>
                <NavLink to="/map" className="nav-link">
                  Map
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/myspots" className="nav-link">
                  My Spots
                </NavLink>
              </NavItem>              
              <NavItem>
                <NavLink to="/news" className="nav-link">
                  News
                </NavLink>
              </NavItem>
            </Nav>
        </div>
        </div>
      </nav>

      <nav className="navbar navbar-expand-md navbar-light d-block d-lg-none bottom-tab-nav" role="navigation" >
        <div className="container-fluid">
           <div className="top-tab-label" style={titleStyle}>
            <a className="navbar-brand" href="/forecast">
                <img alt="Remy Sharp" src="/surf-bros-logo-2.jpg" style={logoStyle} />
                <span>  Surf Bros</span>
              </a>
           </div>
        </div>
      </nav>  
      <nav className="navbar fixed-bottom navbar-light d-block d-lg-none bottom-tab-nav" role="navigation">
        <Nav className="w-100">
          <div className=" d-flex flex-row justify-content-around w-100">
            {
              tabs.map((tab, index) =>(
                <NavItem key={`tab-${index}`}>
                  <NavLink to={tab.route} className="nav-link bottom-nav-link" activeClassName="active">
                    <div className="row d-flex flex-column justify-content-center align-items-center">
                      <FontAwesomeIcon size="lg" icon={tab.icon}/>
                      <div className="bottom-tab-label">{tab.label}</div>
                    </div>
                  </NavLink>
                </NavItem>
              ))
            }
          </div>
        </Nav>
      </nav>
    </div>
  )
};

export default Navigation;
